import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { BufferService, LoadingContext, M_Button, M_Header, M_MessageBoard, NavigateContext } from "src/M_Components"
import { API_BASE_URL } from "src/M_Components/M_Utils/services.config"
import { InvoiceProcess } from "./components/InvoiceProcess"
import { InvoiceDocument } from "./components/InvoiceDocument"
import { InvoiceAgreement } from "./components/InvoiceAgreement"
import { InvoiceCurrency } from "./components/InvoiceCurrency"
import { InvoiceClient } from "./components/InvoiceClient"
import { InvoiceExchange } from "./components/InvoiceExchange"
import { InvoiceHeaderDetails } from "./components/InvoiceHeaderDetails"
import { InvoiceOriginalDocument } from "./components/InvoiceOriginalDocument"
import { InvoiceVat } from "./components/InvoiceVat"
import { Refresh } from "@mui/icons-material"
import axios from 'axios'
import { useMediaQuery } from "@mui/material"


export const InvoiceDetail = ({ roles }) => {
    const ctx = useContext(LoadingContext)
    const navigateCtx = useContext(NavigateContext)
    const { t } = useTranslation()

    const invoiceService = new BufferService("Receivable")

    const [data, setData] = useState({})
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [tabId, setTabId] = useState(sessionStorage.getItem("selectedTab"))
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState()
    const [leavingPage, setLeavingPage] = useState(false)

    const sessionKeys = ["operation", "data", "open", "passedRow"];

    useEffect(() => {
        const passOperation = ctx.passValue.get("operation");
        setOperation(passOperation);

        if (isFirstTime) {
            ctx.setIsLoad(true);
            getSessionStorageData(tabId);
            setIsFirstTime(false);
            sessionStorage.setItem(`tab${tabId}`, JSON.stringify(sessionKeys));
        }
    }, []);

    useEffect(() => {
        const newId = sessionStorage.getItem("selectedTab");
        if (newId !== tabId) {
            setTabId(newId);
            getSessionStorageData(newId);
        }
    }, []);

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(tabId, key, key);
        });
        // eslint-disable-next-line
    }, [tabId, data]);

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
            return;
        if (eval(value) instanceof String && eval(value) === "") return;
        if (eval(value) instanceof Number && eval(value) === "") return;

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(
                `${id}${key}`,
                JSON.stringify(Array.from(eval(value))),
            );
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)));
        }
    };

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`));
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`));
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`));
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`));

        if (
            (tempO && tempO !== "") ||
            (tempD && Object.keys(tempD).length !== 0) ||
            tempOS ||
            (tempPR && Object.keys(tempD).length !== 0)
        ) {
            const row = ctx.passValue.get('row') || tempPR || {}
            const entityData = new Object(tempD)
            const merged = { ...row }
            Object.keys(entityData).forEach(key => {
                if (entityData[key] !== null && entityData[key] !== undefined) {
                    merged[key] = entityData[key]
                }
            })
            setData(merged);
            setPassedRow(tempPR);
            setOperation(tempO)
            ctx.setIsLoad(false);

            return;
        }

        get();
    };

    const get = () => {
        const row = ctx.passValue.get('row') || {}
        invoiceService
            .getId(row.Id)
            .then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages(
                        "error",
                        t("Error"),
                        response?.response?.data?.Errors || response.message,
                    );
                    ctx.setIsLoad(false);
                    return;
                }

                const merged = { ...row }
                Object.keys(response).forEach(key => {
                    if (response[key] !== null && response[key] !== undefined) {
                        merged[key] = response[key]
                    }
                })
                setData(merged);

                ctx.setIsLoad(false);
            })
            .catch((err) => {
                ctx.toastMessages("error", err.message, "Error");
                ctx.setIsLoad(false);
            });

        ctx.setIsLoad(false);
    };
    const baseUrl = sessionStorage.getItem('apiBaseUrl') || API_BASE_URL.main
    const url = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'

    const downloadPdf = () => {
        axios.get(`${url}PrimaveraPdf/${data.Id}/download`, { responseType: "blob" }).then((response) => {
            if (response.name === "AxiosError") {
                ctx.toastMessages(
                    "error",
                    t("Error"),
                    response?.response?.data?.Errors || response.message,
                );
            }
            const contentDisposition = response.headers["content-disposition"];
            let fileName = "receivable.pdf";

            if (contentDisposition) {
                const match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);

                if (match?.[1]) {
                    fileName = decodeURIComponent(match[1]);
                }
            }

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = blobUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        })
    }
    const retry = () => {
        axios.post(`${url}PrimaveraPdf/${data.Id}/retry`).then((response) => {
            if (response.name === "AxiosError") {
                ctx.toastMessages(
                    "error",
                    t("Error"),
                    response?.response?.data?.Errors || response.message,
                );
            }

            ctx.toastMessages(
                "success",
                t("Success"),
                t("RetryReceivableRequestSuccess"),
            );
        })
    }

    const matches11 = useMediaQuery("(min-width:970px)");

    return <div>
        <M_Header
            element={
                <>
                    <M_Button
                        tooltip={t("Back")}
                        label={t("Back")}
                        icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                        onClick={() => setLeavingPage(true)}
                    />
                    {data.Status === "Approved" &&
                        <M_Button
                            tooltip={t("DownloadPdf")}
                            icon={<img src='/icons/svgsDaNet/download.svg' style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)', width: '20px' }} className='downloadPdf' alt='DownloadPdf' />}
                            label={t("DownloadPdf")}

                            onClick={() => { downloadPdf() }}
                        />
                    }

                    {data.Status?.match("Error") &&
                        <M_Button
                            tooltip={t("Retry")}
                            icon={<Refresh />}
                            label={t("Retry")}
                            onClick={() => { retry() }}
                        />
                    }
                </>
            }
        />
        <div>
            <InvoiceVat dataState={data} setDataState={setData} />
        </div>
        <div>
            <InvoiceProcess dataState={data} setDataState={setData} />
        </div>
        <div
            style={{
                display: "grid",
                gridTemplateColumns: matches11 ? "1fr 1fr" : "1fr",
                gap: "16px",
                width: "100%"
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <InvoiceDocument dataState={data} setDataState={setData} />
                <InvoiceClient dataState={data} setDataState={setData} />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <InvoiceAgreement dataState={data} setDataState={setData} />
                <InvoiceCurrency dataState={data} setDataState={setData} />
                <InvoiceExchange dataState={data} setDataState={setData} />
                <InvoiceHeaderDetails dataState={data} setDataState={setData} />
            </div>
        </div>
        <div>
            {/* <InvoiceOriginalDocument dataState={data} setDataState={setData} /> */}
        </div>
        <M_MessageBoard
            warning
            open={leavingPage}
            onClose={() => setLeavingPage(false)}
            title={t("leavingPageTitle")}
            body={t("leavingPageBodyRead")}
            footer={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                    <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => navigateCtx.closeTab(JSON.parse(tabId))} label={t("ButtonConfirm")} />
                </span>
            }
        />
    </div>
}